import { render, staticRenderFns } from "./NavLanguageSelect.vue?vue&type=template&id=8249bcee&scoped=true"
import script from "./NavLanguageSelect.vue?vue&type=script&lang=js"
export * from "./NavLanguageSelect.vue?vue&type=script&lang=js"
import style0 from "./NavLanguageSelect.vue?vue&type=style&index=0&id=8249bcee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8249bcee",
  null
  
)

export default component.exports